exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".m0H48WwqdFf3FsxFXauUJ{max-width:500px!important;width:430px!important}", ""]);
// Exports
exports.locals = {
	"errorModal": "m0H48WwqdFf3FsxFXauUJ"
};